import { render, staticRenderFns } from "./discipline.vue?vue&type=template&id=364ea6e8&scoped=true&"
import script from "./discipline.vue?vue&type=script&lang=js&"
export * from "./discipline.vue?vue&type=script&lang=js&"
import style0 from "./discipline.vue?vue&type=style&index=0&id=364ea6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ea6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364ea6e8')) {
      api.createRecord('364ea6e8', component.options)
    } else {
      api.reload('364ea6e8', component.options)
    }
    module.hot.accept("./discipline.vue?vue&type=template&id=364ea6e8&scoped=true&", function () {
      api.rerender('364ea6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/discipline.vue"
export default component.exports